package co.maytes.standupbot.dashboard.components.feedback

import androidx.compose.runtime.Composable

enum class ModalSize(val widthPx: Int) {
    Sm(440),
    Md(600),
    Lg(880),
}

@Composable
fun ModalShell(
    onDismiss: () -> Unit,
    size: ModalSize = ModalSize.Sm,
    dismissOnBackdrop: Boolean = true,
    fullscreen: Boolean = false,
    content: @Composable () -> Unit,
) {
    Modal(
        onDismiss = onDismiss,
        size = size,
        fullscreen = fullscreen,
        dismissOnScrim = dismissOnBackdrop,
        showClose = false,
        content = content,
    )
}
